__turbopack_context__.v({
  "caseItem": "style-module-scss-module__8pnqKG__caseItem",
  "caseItemReveal": "style-module-scss-module__8pnqKG__caseItemReveal",
  "casesGrid": "style-module-scss-module__8pnqKG__casesGrid",
  "showMoreBtn": "style-module-scss-module__8pnqKG__showMoreBtn",
  "showMoreWrapper": "style-module-scss-module__8pnqKG__showMoreWrapper",
  "titleWrapper": "style-module-scss-module__8pnqKG__titleWrapper",
});
